(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peptrolix-product"] && !Shopify.designMode) return;
  try {
    
  // Progressive enhancement only. The tier radios are named `quantity` inside the
  // product form, so the correct quantity is submitted with or without this script.
  // All this does is keep the price on the submit button in step with the selection.
  (function () {
    function syncTotal(fieldset) {
      var form = fieldset.form || fieldset.closest('form');
      if (!form) return;

      var target = form.querySelector('[data-pxp-submit-total]');
      var selected = fieldset.querySelector('.pxp-tier__input:checked');
      if (!target || !selected) return;

      var total = selected.getAttribute('data-pxp-tier-total');
      if (total) target.textContent = total;
    }

    function init() {
      var groups = document.querySelectorAll('.pxp-tiers');

      for (var i = 0; i < groups.length; i++) {
        (function (fieldset) {
          syncTotal(fieldset);
          fieldset.addEventListener('change', function (event) {
            if (event.target.classList.contains('pxp-tier__input')) syncTotal(fieldset);
          });
        })(groups[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // The theme editor replaces the section's DOM without re-running this file, so
    // the listeners above would be lost exactly where a merchant is configuring tiers.
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peptrolix-routine-builder"] && !Shopify.designMode) return;
  try {
    
  class PeptrolixRoutineBuilder extends HTMLElement {
    connectedCallback() {
      this.options = Array.from(this.querySelectorAll('[data-prb-option]'));
      this.countEl = this.querySelector('[data-prb-count]');
      this.totalEl = this.querySelector('[data-prb-total]');
      this.submitEl = this.querySelector('[data-prb-submit]');
      this.statusEl = this.querySelector('[data-prb-status]');
      this.cartUrl = this.dataset.cartUrl || '/cart/add';
      this.cartPage = this.dataset.cartPage || '/cart';

      this.strings = {
        none: this.countEl ? this.countEl.textContent.trim() : '',
        one: this.dataset.oneLabel || '1 selected',
        many: this.dataset.manyLabel || '%count% selected',
        error: this.dataset.errorLabel || 'Something went wrong. Please try again.'
      };

      this.options.forEach((option) => {
        option.addEventListener('change', () => this.refresh());
      });

      if (this.submitEl) {
        this.submitEl.addEventListener('click', () => this.addSelected());
      }

      this.refresh();
    }

    get selected() {
      return this.options.filter((option) => option.checked && !option.disabled);
    }

    // Renders through the shop's own money format setting, so the running total
    // looks like every other price on the storefront instead of a bare number
    // with an ISO code bolted on. The pattern is built from character classes
    // because a literal double-brace in this block would read as a Liquid tag.
    formatMoney(cents) {
      const format = this.dataset.moneyFormat || '';
      const pattern = new RegExp('[{][{]\\s*([a-z_]+)\\s*[}][}]');
      const placeholder = format.match(pattern);
      let amount = (cents / 100).toFixed(2);

      if (!placeholder) return amount;

      if (placeholder[1].indexOf('no_decimals') !== -1) {
        amount = String(Math.round(cents / 100));
      } else if (placeholder[1].indexOf('comma_separator') !== -1) {
        amount = amount.replace('.', ',');
      }

      return format.replace(placeholder[0], amount);
    }

    refresh() {
      const chosen = this.selected;
      const total = chosen.reduce((sum, option) => sum + Number(option.dataset.price || 0), 0);

      if (this.countEl) {
        if (chosen.length === 0) {
          this.countEl.textContent = this.strings.none;
        } else if (chosen.length === 1) {
          this.countEl.textContent = this.strings.one;
        } else {
          this.countEl.textContent = this.strings.many.replace('%count%', chosen.length);
        }
      }

      if (this.totalEl) {
        this.totalEl.textContent = chosen.length ? this.formatMoney(total) : '';
      }

      if (this.submitEl) {
        this.submitEl.disabled = chosen.length === 0;
      }
    }

    async addSelected() {
      const chosen = this.selected;
      if (!chosen.length || !this.submitEl) return;

      this.submitEl.disabled = true;
      if (this.statusEl) this.statusEl.textContent = '';

      const items = chosen.map((option) => ({ id: Number(option.value), quantity: 1 }));

      try {
        const response = await fetch(this.cartUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!response.ok) throw new Error('cart-error');

        window.location.href = this.cartPage;
      } catch (error) {
        if (this.statusEl) this.statusEl.textContent = this.strings.error;
        this.submitEl.disabled = false;
      }
    }
  }

  if (!customElements.get('peptrolix-routine-builder')) {
    customElements.define('peptrolix-routine-builder', PeptrolixRoutineBuilder);
  }

  } catch(e) { console.error(e); }
})();
})();
